import { combineSlices, configureStore } from '@reduxjs/toolkit'
import { apiSlice } from './api';
import { currentRegionSlice, currentStateSlice, poiTypesSlice } from './settingsSlices';
import { loadingProgressSlice } from './loadingProgressSlice';

const rootReducer = combineSlices(
    apiSlice, 
    currentStateSlice, currentRegionSlice, poiTypesSlice, loadingProgressSlice
);

export const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => {
        return getDefaultMiddleware()
          .concat(apiSlice.middleware)
      },
})
